module.exports = __webpack_public_path__ + "src/img/load.16aae04b.svg";